import mildHearingSideImage from '@/components/results-category/images/mild-hearing-loss-side-image.webp';
import normalHearingSideImage from '@/components/results-category/images/normal-hearing-side-image.webp';
import moderateHearingSideImage from '@/components/results-category/images/moderate-hearing-loss-side-image.webp';
import { palette } from '@/theme/palette';
export var resultCategoryImages = {
    mildHearingSideImage: mildHearingSideImage,
    normalHearingSideImage: normalHearingSideImage,
    moderateHearingSideImage: moderateHearingSideImage,
};
export var moderateCategory = {
    emphasizedText: 'moderate (or greater) hearing loss',
    textColor: palette.custom.moderateCategory.main,
};
export var mildCategory = {
    emphasizedText: 'mild hearing loss',
    textColor: palette.custom.mildCategory.main,
};
export var normalCategory = {
    emphasizedText: 'normal hearing',
    textColor: palette.custom.normalCategory.main,
};
